import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const questionsModel = [
  {
    field: 'zalud_coldFlu_redFlagSymptoms',
    label: 'Are you experiencing any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Gasping for air', key: 'gasping_for_air' },
        { value: 'Lips that are gray or blue', key: 'gray_blue_lips' },
        {
          value:
            'Chest pain or pressure not related to coughing or deep breathing',
          key: 'chest_pain_pressure'
        },
        { value: 'Coughing up blood', key: 'coughing_up_blood' },
        {
          value: 'New confusion or difficulty staying awake',
          key: 'confusion_difficulty_awake'
        },
        {
          value: 'Inability to keep fluids down (persistent vomiting)',
          key: 'inability_keep_fluids_down'
        },
        {
          value:
            'Facial or throat swelling, or difficulty swallowing',
          key: 'facial_throat_swelling'
        },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_worseningOrProlonged',
    label:
      'Are your symptoms getting worse after initially improving, or have they lasted more than 10 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes, my symptoms improved and then got worse again',
          key: 'improved_then_worse'
        },
        {
          value: 'Yes, my symptoms have lasted more than 10 days',
          key: 'lasted_more_than_10_days'
        },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_symptomOnsetTiming',
    label: 'When did your symptoms start?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '1 - 2 days ago', key: '1_to_2_days_ago' },
        { value: '3 - 5 days ago', key: '3_to_5_days_ago' },
        { value: '6 - 10 days ago', key: '6_to_10_days_ago' },
        { value: '10 + days ago', key: '10_plus_days_ago' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_fever',
    label: 'Do you currently have a fever?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No fever', key: 'no_fever' },
        { value: 'Mild fever (100.4–102°F)', key: 'mild_fever' },
        { value: 'High fever (>102°F)', key: 'high_fever' },
        { value: "I don't know", key: 'unknown' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_feverDuration',
    label: 'How many days have you had a fever?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: '1–2 days', key: '1_to_2_days' },
        { value: '3–4 days', key: '3_to_4_days' },
        { value: '5 or more days', key: '5_or_more_days' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_symptoms',
    label: 'Which of these symptoms are you experiencing?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Dry cough', key: 'dry_cough' },
        { value: 'Wet or productive cough', key: 'wet_cough' },
        { value: 'Shortness of breath', key: 'shortness_of_breath' },
        { value: 'Nasal congestion or runny nose', key: 'nasal_congestion' },
        { value: 'Sore throat', key: 'sore_throat' },
        { value: 'Ear pain', key: 'ear_pain' },
        { value: 'Facial pain or pressure', key: 'facial_pain_pressure' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_additionalSymptoms',
    label: 'Are you experiencing any of these additional symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Chills', key: 'chills' },
        { value: 'Significant muscle or body aches', key: 'muscle_body_aches' },
        { value: 'Severe fatigue or exhaustion', key: 'severe_fatigue' },
        { value: 'Headache', key: 'headache' },
        { value: 'Upset stomach or diarrhea', key: 'upset_stomach_diarrhea' },
        { value: 'Loss of taste or smell', key: 'loss_taste_smell' },
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_symptomOnset',
    label: 'How did your symptoms start?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Suddenly (all at once)', key: 'suddenly' },
        { value: 'Gradually (it built up over a day or two)', key: 'gradually' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_chronicLungDisease',
    label:
      'Do you have a history of asthma, COPD, or other chronic lung disease?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_covidFluTestResult',
    label: 'Have you been tested for COVID-19 or influenza?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Tested positive for COVID-19', key: 'positive_covid19' },
        { value: 'Tested positive for influenza', key: 'positive_influenza' },
        {
          value: 'Tested negative for both or all tests taken',
          key: 'negative'
        },
        { value: 'Not been tested', key: 'not_tested' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_closeContact',
    label:
      'Have you been in close contact (within 6 feet for 15+ minutes) with someone diagnosed with COVID-19 or influenza in the past 10 days?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes, COVID-19', key: 'yes_covid19' },
        { value: 'Yes, Influenza', key: 'yes_influenza' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'not_sure' }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_additionalComments',
    label:
      'Are there any additional symptoms or comments related to your current condition that were not covered in this form?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'zalud_coldFlu_additionalComments'
    }
  },
  {
    field: 'zalud_coldFlu_consent',
    label: 'Consent',
    type: 'select',
    educationalSlide: `I consent that by submitting this form I acknowledge that the responses are truthful and accurate to the best of my knowledge, and understand that if I am or become pregnant, or use medications off-label, I should consult a qualified health care professional for individualized guidance.`,
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'do_not_proceed'
        },
        {
          value:
            'I have read and understand the information and I wish to proceed',
          class: 'option-consent',
          key: 'proceed'
        }
      ]
    }
  },
  {
    field: 'zalud_coldFlu_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'zalud_coldFlu_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to continue based on your responses.",
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

export type ZaludColdFluQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
>;
export default questionsModel;
